var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutlinedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47953 4.47953 0 10 0C15.5205 0 20 4.47953 20 10C20 15.5205 15.5205 20 10 20C4.47953 20 0 15.5205 0 10ZM1.66667 10C1.66667 5.4 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.4 18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10ZM9.16667 12.5V14.1667H10.8333V12.5H9.16667ZM9.16667 10.8333H10.8333V5.83333H9.16667V10.8333Z",
    fill: "#FF7A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutlinedRed);
export default __webpack_public_path__ + "static/media/info-outlined-red.652dc11a3be351642e7572be58432b0e.svg";
export { ForwardRef as ReactComponent };